export enum Web2AppLinkCopyResult {
  SUCCESS = 'success',
  FAIL = 'fail',
}
